import { Button } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { mainProductConfig } from 'constants/mainProductConfig'
import classNames from 'classnames'
import { FdrPage, BillsPage } from 'utils/environmentConfig'
export default function HeaderCta({
  siteEnv = 'achieve',
  className = '',
  'data-testid': dataTestId,
  linkUrl,
  linkText,
  event,
  variantText = 'bodySm',
  condensed,
  textClassName = '',
  buttonClassName = '',
  ...buttonProps
}) {
  return (
    <AchieveLink
      className={className}
      href={linkUrl}
      data-testid={dataTestId}
      track={{
        ...{
          list_name: 'Header Nav Main CTA Button',
          click_id: 'Get Started',
          click_text: `${
            mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
          } | Get Started`,
          nav_link_section: 'Header',
          track_event: 'global_header',
          event_action: 'button_click',
          event_type: 'button_click',
        },
        ...event,
      }}
    >
      <Button
        color="primary"
        variant="contained"
        className={classNames(
          {
            'bg-[#cb000e] text-white hover:text-white': siteEnv === FdrPage && condensed,
            'bg-[#104c81] text-white hover:text-white': siteEnv === BillsPage && condensed,
            'bg-white text-blue-600 border-solid border-2 border-blue-600':
              siteEnv === FdrPage && !condensed,
            'py-1 whitespace-nowrap': siteEnv === FdrPage,
          },
          buttonClassName
        )}
        {...buttonProps}
      >
        <Typography
          variant={variantText}
          className={`font-extrabold! ${textClassName}`}
          fontWeight="extrabold"
        >
          {linkText ? linkText : `Get Started`}
        </Typography>
      </Button>
    </AchieveLink>
  )
}
